import React from 'react';
export function EditorListNumberIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M4 5.051c0-.18.106-.344.271-.417l1.097-.488a.829.829 0 01.272-.119.45.45 0 01.222-.022.417.417 0 01.388.416v2.833h.25a.5.5 0 010 1h-2a.5.5 0 010-1H5V5.31l-.358.159A.457.457 0 014 5.05zm0 5.203h1.573a.427.427 0 01.19.81L4 11.944v1.31h3v-1H5.618l.593-.297a1.427 1.427 0 00-.638-2.704H4v1zm.5 5a.5.5 0 100 1h1.25v1H5a.5.5 0 100 1h.75v1H4.5a.5.5 0 100 1h2a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5h-2zM21 5H9v2h12V5zm0 6H9v2h12v-2zM9 17h12v2H9v-2z"
  }));
}